import { configureStore } from '@reduxjs/toolkit';
import translationReducer from '../../../../common/lib/redux/slices/translationSlice';

export const store = configureStore({
  reducer: {
    translations: translationReducer,
  },
});

export type CyberState = ReturnType<typeof store.getState>;
export type CyberDispatch = typeof store.dispatch;

export default store;
